module.exports = __webpack_public_path__ + "img/mission_Image_one.fd27ec31.png";